import { v4 as uuid4 } from 'uuid';
import type { ConfigFee } from '../graphql/types';

export const getConfigFees = (configs: ConfigFee[]): ConfigFee[] => {
  if (!Array.isArray(configs)) return [];
  return configs.filter((cf) => cf.isPreFunding);
};

export const getConfigCommissions = (configs: ConfigFee[]): ConfigFee[] => {
  if (!Array.isArray(configs)) return [];
  return configs.filter((cf) => cf.isCommission);
};

export type FeeCommissionFormRow = {
  id: string;
  configId: string;
  amount: number;
  comment: string;
  config: ConfigFee;
  isPaid?: boolean;
};


export const addResolvedConfigToItems = <T extends object>(
  items: T[],
  configFees: ConfigFee[]
): (T & { config?: ConfigFee })[] =>
  items.map((item) => {
    const configId = (item as { configId?: string }).configId;
    const config = configId ? configFees.find((cf) => cf.id === configId) : null;
    return { ...item, ...(config ? { config } : {}) } as T & { config?: ConfigFee };
  });

export const createPresetFeeCommissionRow = (
  cf: ConfigFee,
  baseAmount: number,
  overrides?: Partial<FeeCommissionFormRow>
): FeeCommissionFormRow => ({
  id: uuid4(),
  configId: cf.id,
  amount: cf.isPercentage ? (baseAmount * (cf.defaultAmount || 0)) / 100 : (cf.defaultAmount || 0),
  comment: cf.defaultComment || '',
  config: cf,
  ...overrides
});
